<template>
  <div>
    <el-row>
      <el-col :span="20" style="margin-top: 20px">
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleCurrentChange(1)" style="float:right">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="出库数量"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="退库数量"></el-table-column>
          <el-table-column prop="WASTAGE_COUNT" label="报损数量"></el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="成本价"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="成本总金额"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="editOutCount(scope.row)" type="text" :disabled="false"
                v-if="scope.row.WASTAGE_COUNT < 0">添加出库数量</el-button>
              <el-button @click="editOutCount(scope.row)" type="text" :disabled="true" v-else>添加出库数量</el-button>
              <el-button @click="editReturnCount(scope.row)" type="text" v-show="deliverStatus == 3">退货</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <el-dialog title="修改产品" center :visible.sync="editFormVisible" width="600px">
      <el-form size="small" :model="editForm" ref="editForm">
        <p>产品名称：{{ editForm.NAME }}</p>
        <p>单位：{{ editForm.TYPE_UNIT }}</p>
        <el-table :data="editData" border stripe>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="BATCH" label="批次"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="库存数量"></el-table-column>
          <el-table-column prop="OUT_COUNT" label="出库数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.OUT_COUNT"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="退货" center :visible.sync="returnFormVisible" width="400px">
      <el-form size="small" :model="returnForm" ref="returnForm">
        <el-form-item label="产品名称：" label-width="120px">
          {{ returnForm.NAME }}
        </el-form-item>
        <el-form-item label="单位：" label-width="120px">
          {{ returnForm.TYPE_UNIT }}
        </el-form-item>
        <el-form-item label="退货数量：" label-width="120px">
          <el-input v-model="returnForm.COUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeReturn">取 消</el-button>
        <el-button size="small" @click="submitReturn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  totalOutDetailFun, findWareFun, editOutFun, totalReturnFun,
} from 'api/warehouseManager';

export default {
  data() {
    return {
      tableData: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {},
      editForm: {},
      editFormVisible: false,
      formLabelWidth: '120px',
      editData: [],
      returnFormVisible: false,
      returnForm: {},
      deliverStatus: sessionStorage.getItem('deliverStatus'),
    };
  },
  methods: {
    queryTable(e) {
      const params = {
        DELIVER_ID: sessionStorage.getItem('deliverId'),
        PAGESIZE: this.pageSize,
        PAGEINDEX: e,
      };
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      totalOutDetailFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable(e - 1);
    },
    editOutCount(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.findWareHouse(row.ID);
    },
    findWareHouse(e) {
      const params = {
        DETAIL_ID: e,
      };
      findWareFun(params).then((result) => {
        if (result) {
          this.editData = result.map((item) => ({ BATCH: item.BATCH, PRODUCT_COUNT: item.PRODUCT_COUNT, OUT_COUNT: item.PRODUCT_COUNT }));
        } else {
          this.editData = [];
          this.$message.show({ text: '暂无库存数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    close() {
      this.editFormVisible = false;
    },
    editReturnCount(row) {
      this.returnFormVisible = true;
      this.returnForm = row;
    },
    submitEdit() {
      const submitArr = this.editData.map((item) => ({ BATCH: item.BATCH, DELIVER_COUNT: item.OUT_COUNT }));
      const params = {
        DETAIL_ID: this.editForm.ID,
        PRODUCT_ARRAY: submitArr,
      };
      editOutFun(params).then((result) => {
        this.$message.show({ text: '出库成功', type: 'warning' });
        this.editFormVisible = false;
        this.queryTable(0);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closeReturn() {
      this.returnFormVisible = false;
    },
    submitReturn() {
      const params = {
        TOTAL_ID: sessionStorage.getItem('deliverId'),
        DETAIL_ID: this.returnForm.ID,
        RETURN_COUNT: this.returnForm.COUNT,
        WASTAGE_COUNT: this.returnForm.WASTAGE_COUNT,
      };
      totalReturnFun(params).then((result) => {
        this.$message.show({ text: '退货成功', type: 'success' });
        this.returnFormVisible = false;
        this.queryTable(0);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/totalOutDetail.vue